export default "__VITE_ASSET__BZxj7Ysw__"